import { api } from '@/core/helpers/axiosHelper';
import { TimetableWeek } from './timetable-week.interface';

export default {
   async delete(timetable_week_id: number) {
      return await api.delete('/timetable-week/' + timetable_week_id).then((response) => {
         return response;
      });
   },
   async post(body: TimetableWeek) {
      return await api.post('/timetable-week?include=timetable_days.timetable_hours', body).then((response) => {
         return response.data;
      });
   },
   async put(timetable_week_id: number, body: TimetableWeek) {
      return await api
         .put(`/timetable-week/${timetable_week_id}?include=timetable_days.timetable_hours`, body)
         .then((response) => response?.data)
         .catch((error) => Promise.reject(error));
   },
};
